var map = {
	"./jb1.png": "./src/assets/chou/jb1.png",
	"./jb2.png": "./src/assets/chou/jb2.png",
	"./jb3.png": "./src/assets/chou/jb3.png",
	"./jb4.png": "./src/assets/chou/jb4.png",
	"./jb5.png": "./src/assets/chou/jb5.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/chou sync recursive ^\\.\\/jb.*\\.png$";